function handleScroll() {
  const scrollClass = 'scrolled-to-top';

  if (window.scrollY === 0) {
    document.body.classList.add(scrollClass);
  } else {
    document.body.classList.remove(scrollClass);
  }
}

window.addEventListener('scroll', handleScroll);
document.addEventListener('DOMContentLoaded', handleScroll);
